module.exports = __webpack_public_path__ + "static/img/software7.d390eaf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/software7.jpg
// module id = lW58
// module chunks = 2